/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2019年08月25日</li>
 * <li>@author     : ____′↘夏悸</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';

export default {
	template: {
		list() {
			return Ajax.get("/report/template")
		},
		load(id) {
			return Ajax.get(`/report/template/${id}`)
		},
		delete(id) {
			return Ajax.delete(`/report/template/${id}`)
		},
		save(params = {}) {
			return Ajax.post(`/report/template`, params)
		},
		update(params = {}) {
			return Ajax.put(`/report/template`, params)
		},
		items: {
			save(params = {}) {
				return Ajax.post(`/report/template/items`, params)
			},
			update(params = {}) {
				return Ajax.put(`/report/template/items`, params)
			},
			delete(id) {
				return Ajax.delete(`/report/template/items/${id}`)
			},
			formula(params) {
				return Ajax.post(`/report/template/items/formula`, params)
			}
		},
		reset(id) {
			return Ajax.post(`/report/template/${id}/reset`)
		}
	},
	getTemplates(accountSetsId) {
		return Ajax.get(`/report/template`, { accountSetsId })
	},
	resetTemplate(accountSetsId, templateId) {
		return Ajax.post(`/report/template/${templateId}/reset`, { accountSetsId })
	},
	view(id, params = {}) {
		return Ajax.get(`/report/template/view/${id}`, params)
	},
	cashFlowApply(params = {}) {
		return Ajax.post(`/report/cash-flow/config/apply`, params)
	},
	cashFlowConfig() {
		return Ajax.get(`/report/cash-flow/config`)
	},
	cashFlowApplyStandard(params = {}) {
		return Ajax.post(`/report/cash-flow/config/apply-standard`, params)
	},
	cashFlowUnmapped(params = {}) {
		return Ajax.get(`/report/cash-flow/config/unmapped`, params)
	},
	cashFlowValidate(params = {}) {
		return Ajax.get(`/report/cash-flow/config/validate`, params)
	},
	cashFlowAutoMap(params = {}) {
		return Ajax.post(`/report/cash-flow/config/auto-map`, params)
	},
	cashFlowOpening(params = {}) {
		return Ajax.get(`/report/cash-flow/config/opening`, params)
	},
	saveCashFlowOpening(params = {}) {
		return Ajax.post(`/report/cash-flow/config/opening`, params)
	},
	deleteCashFlowOpening(accountDate) {
		return Ajax.delete(`/report/cash-flow/config/opening?accountDate=${encodeURIComponent(accountDate)}`)
	},
	// 获取报表项目关联的凭证明细
	getItemVouchers(params = {}) {
		return Ajax.get('/report/template/item/vouchers', params)
	},
	// 导出功能
	export: {
		// 导出利润表
		profitStatement(params = {}) {
			return Ajax.download(`/report/export/profit-statement`, params)
		},
		// 导出资产负债表
		balanceStatement(params = {}) {
			return Ajax.download(`/report/export/balance-statement`, params)
		},
		// 导出现金流量表
		cashFlowStatement(params = {}) {
			return Ajax.download(`/report/export/cash-flow-statement`, params)
		},
		// 通用报表导出
		template(templateId, params = {}) {
			return Ajax.download(`/report/export/template/${templateId}`, params)
		}
	},
	snapshot: {
		preview(params = {}) {
			return Ajax.get('/report/snapshot/preview', params)
		},
		generate(params = {}) {
			return Ajax.post('/report/snapshot/generate', params)
		},
		list() {
			return Ajax.get('/report/snapshot/list')
		},
		detail(id) {
			return Ajax.get(`/report/snapshot/${id}`)
		},
		saveShare(id, params = {}) {
			return Ajax.post(`/report/snapshot/${id}/share`, params)
		},
		getShare(id) {
			return Ajax.get(`/report/snapshot/${id}/share`)
		},
		shareMeta(token) {
			return Ajax.get(`/report/snapshot/share/${token}/meta`)
		},
		shareView(token, params = {}) {
			return Ajax.post(`/report/snapshot/share/${token}/view`, params, { repeatable: true })
		}
	},
	merge: {
		accountSets() {
			return Ajax.get('/report/merge/account-sets')
		},
		preview(params = {}) {
			return Ajax.post('/report/merge/preview', params)
		},
		aiEliminations(params = {}) {
			return Ajax.post('/report/merge/ai-eliminations', params)
		},
		export(params = {}) {
			return Ajax.downloadPost('/report/merge/export', params)
		}
	}
}
